















import OtDocumentLayout from '@/components/documents/document-layout/ot-document-layout.vue';
import { Component, Vue } from 'vue-property-decorator';
import { ROUTE_WORKFLOW_DOCUMENT, ROUTE_WORKFLOW_DOCUMENT_ASSOCIATIONS } from './claims-routes';

@Component({
  components: {
    OtDocumentLayout,
  },
})
export default class OtProjectDocumentLayout extends Vue {
  private get detailsRouteName() {
    return ROUTE_WORKFLOW_DOCUMENT;
  }
  private get associationsRouteName() {
    return ROUTE_WORKFLOW_DOCUMENT_ASSOCIATIONS;
  }
}
